module.exports = __webpack_public_path__ + "static/media/img_title2@2x.3da5f0f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_title2@2x.png
// module id = 780
// module chunks = 0